import { FormDialog } from "components/common/FormDialog";
import {
  FIELD_TYPES,
  FormDialogProps
} from "components/common/FormDialog/types";
import { supportActions } from "modules/support/slices";
import { FC, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { mixed, string } from "yup";
import { ContactSupportDialogProps } from "./types";
import { userSelector } from "modules/auth/selectors";

const PRIORITY_OPTIONS = [
  { label: "Low", value: "4", color: "success" as const },
  { label: "Medium", value: "3", color: "info" as const },
  { label: "High", value: "2", color: "warning" as const },
  { label: "Critical", value: "1", color: "error" as const }
];

export const ContactSupportDialog: FC<ContactSupportDialogProps> = ({
  isOpened,
  onClose
}) => {
  const dispatch = useDispatch();
  const user = useSelector(userSelector);

  const handleContactFormSubmit = useCallback(
    (data: { subject: string; description: string; priority: string }) => {
      dispatch(
        supportActions.submitTicketRequest({
          subject: data.subject.trim(),
          description: data.description.trim(),
          priority: parseInt(data.priority, 10),
          customer_id: user?.attributes?.["customer_id"]?.[0] || "",
          mobile: user?.attributes?.["info:mobile"]?.[0] || ""
        })
      );
      onClose();
    },
    [dispatch, onClose, user]
  );

  const dialogProps: Omit<FormDialogProps, "isOpened" | "onCancel"> = {
    onConfirm: handleContactFormSubmit,
    title: "Contact support",
    confirmButtonLabel: "Submit ticket",
    fields: [
      {
        name: "subject",
        type: FIELD_TYPES.TEXT,
        label: "Subject",
        variant: "outlined",
        rules: string().required()
      },
      {
        name: "description",
        type: FIELD_TYPES.MULTILINE_TEXT,
        variant: "outlined",
        defaultValue: `\n`,
        label: "Description",
        rules: string().required()
      },
      {
        name: "divider_1",
        type: FIELD_TYPES.DIVIDER,
        label: "Priority",
        labelOffset: 8
      },
      {
        name: "priority",
        type: FIELD_TYPES.TOGGLE_BUTTON,
        label: "Priority",
        defaultValue: "3",
        options: PRIORITY_OPTIONS,
        rules: mixed().required()
      }
    ]
  };

  return (
    <FormDialog
      isOpened={isOpened}
      onCancel={onClose}
      fields={dialogProps.fields}
      onConfirm={dialogProps.onConfirm}
      title={dialogProps.title}
      confirmButtonLabel={dialogProps.confirmButtonLabel}
    />
  );
};
